import React, {Suspense} from 'react';
import {Redirect, Route, Switch} from "react-router-dom";

import ClinicDashboard from "./pages/Clinic/Dashboard/Dashboard";
import ClinicPatients from "./pages/Clinic/Patients/Patients";
import ClinicPatient from "./pages/Clinic/Patient/Patient";
import HelpCenter from "./pages/Clinic/HelpCenter/HelpCenter";
import ClinicAccount from "./pages/Clinic/Account/Account";
import ClinicTreatmentParameters from "./pages/Clinic/Parameters/Parameters";
import ClinicStaffMembers from "./pages/Clinic/StaffMembers/StaffMembers";
import ClinicStaffMember from "./pages/Clinic/StaffMember/StaffMember";
import ClinicTreatments from "./pages/Clinic/Treatments/Treatments";
import ClinicService from "./pages/Clinic/Service/Service";
import ClinicPlatforms from "./pages/Clinic/Platforms/Platforms";
import ClinicPlatform from "./pages/Clinic/Platform/Platform";
import ClinicReports from 'pages/Clinic/Reports/Reports';
import ClinicReport from 'pages/Clinic/Report/Report';
import ChainReports from 'pages/Chain/Reports/Reports';
import ChainReport from 'pages/Chain/Report/Report';
import DistributorReports from 'pages/Distributor/Reports/Reports';
import DistributorReport from 'pages/Distributor/Report/Report';
import Report from 'pages/Auth/Report/Report';
import PageNotFound from "./pages/General/PageNotFound/PageNotFound";
import ChainDashboard from "./pages/Chain/Dashboard/Dashboard";
import ChainAccount from "./pages/Chain/Account/Account";
import ChainClinics from "./pages/Chain/Clinics/Clinics";
import ChainClinic from "./pages/Chain/Clinic/Clinic";
import ChainPatients from "./pages/Chain/Patients/Patients";
import ChainPatient from "./pages/Chain/Patient/Patient";
import ChainPlatformsPage from "./pages/Chain/Platforms/Platforms";
import ChainApplicatorsPage from "./pages/Chain/Applicators/Applicators";
import ChainTreatments from "./pages/Chain/Treatments/Treatments";
import ChainService from "./pages/Chain/Service/Service";
import Login from "./pages/Auth/Login/Login";
import Register from "./pages/Auth/Register/Register";
import ForgotPassword from "./pages/Auth/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/Auth/ResetPassword/ResetPassword";
import Verify from "./pages/Auth/Verify/Verify";
import ClinicApplicatorsPage from "./pages/Clinic/Applicators/Applicators";
import ChainStaffMembers from "./pages/Chain/StaffMembers/StaffMembers";
import ChainStaffMember from "./pages/Chain/StaffMember/StaffMember";
import DistributorDashboard from "./pages/Distributor/Dashboard/Dashboard";
import DistributorClinicsAndChains from "./pages/Distributor/ClinicsAndChains/ClinicsAndChains";
import DistributorAccount from "./pages/Distributor/Account/Account";
import DistributorPlatforms from "./pages/Distributor/Platforms/Platforms";
import DistributorApplicators from "./pages/Distributor/Applicators/Applicators";
import DistributorService from "./pages/Distributor/Service/Service";
import DistributorClinic from "./pages/Distributor/Clinic/Clinic";
import DistributorPlatform from "./pages/Distributor/Platform/Platform";
import ChainPlatform from "./pages/Chain/Platform/Platform";
import AdminDashboard from "./pages/Admin/Dashboard/Dashboard";
import AdminClinicsAndChains from "./pages/Admin/ClinicsAndChains/ClinicsAndChains";
import AdminAccount from "./pages/Admin/Account/Account";
import AdminService from "./pages/Admin/Service/Service";
import AdminDistributors from "./pages/Admin/Distributors/Distributors";
import AdminPlatforms from "./pages/Admin/Platforms/Platforms";
import AdminPlatform from "./pages/Admin/Platform/Platform";
import AdminApplicators from './pages/Admin/Applicators/Applicators';
import AdminDistributor from "./pages/Admin/Distributor/Distributor";
import AdminClinic from "./pages/Admin/Clinic/Clinic";
import TermsAgreement from 'components/TermsAgreement';
import AdminPlatformVersions from "./pages/Admin/PlatformVersions/PlatformVersions";
import ClientBook from './pages/Book/ClientBook/ClientBook';
import ClinicBooking from './pages/Clinic/Booking/Booking';
import AdminUsers from "./pages/Admin/Users/Users";
import ClinicEmailPreferences from 'pages/Clinic/EmailPreferences/EmailPreferences';

export const createLoginRoutes = () => (
    <Suspense fallback={<p>LOADING...</p>}>
        <Switch>
            <Route path="/login" component={Login}/>
            <Route path="/register" component={Register}/>
            <Route path="/forgot-password" component={ForgotPassword}/>
            <Route path="/reset-password/:id/:token" component={ResetPassword}/>
            <Route path="/verify/:id/:token" component={Verify} />
            <Route path="/content/:title" component={TermsAgreement} />
            <Route path={`/report/:token`} component={Report}/>
            <Route path={`/book/:clinicId/:token`} component={ClientBook}/>
            <Route path={`/book/:clinicId`} component={ClientBook}/>

            <Route exact path="/">
                <Redirect to="/login"/>
            </Route>

            <Route path="*" component={Login} />
        </Switch>
    </Suspense>
);


export const createClinicRoutes = () => (
    <Suspense fallback={<p>LOADING...</p>}>
        <Switch>
            {/*<Route path="/404" component={PageNotFound}/>*/}
            <Route exact path="/dashboard" component={ClinicDashboard} />
            <Route path={`/account`} component={ClinicAccount}/>
            <Route path={`/parameters`} component={ClinicTreatmentParameters}/>
            <Route path={`/patient/:id`} component={ClinicPatient}/>
            <Route path="/patients" component={ClinicPatients}/>
            <Route path={`/help`} component={HelpCenter}/>
            <Route exact path={`/staff`} component={ClinicStaffMembers}/>
            <Route path={`/staff/:id`} component={ClinicStaffMember}/>
            <Route path={`/treatments`} component={ClinicTreatments}/>
            <Route path={`/service`} component={ClinicService}/>
            <Route path={`/equipment/platforms`} component={ClinicPlatforms}/>
            <Route path={`/equipment/platform/:id`} component={ClinicPlatform}/>
            <Route path="/equipment/applicators" component={ClinicApplicatorsPage}/>
            <Route path="/reports" component={ClinicReports}/>
            <Route path={`/report/:token`} component={ClinicReport}/>
            <Route path="/content/:title" component={TermsAgreement} />
            <Route path={`/book/:clinicId/:token`} component={ClientBook}/>
            <Route path={`/book/:clinicId`} component={ClientBook}/>
            <Route path="/booking" component={ClinicBooking}/>
            <Route path={`/email/preferences`} component={ClinicEmailPreferences}/>

            <Route exact path="/">
                <Redirect to="/dashboard"/>
            </Route>
            <Route exact path="/login">
                <Redirect to="/dashboard"/>
            </Route>

            <Route path="*" component={PageNotFound} />
            {/*<Route path="*">*/}
            {/*    <Redirect to="/404"/>*/}
            {/*</Route>*/}
        </Switch>
    </Suspense>
);

export const createChainRoutes = () => (
    <Suspense fallback={<p>LOADING...</p>}>
        <Switch>
            <Route exact path="/dashboard" component={ChainDashboard} />
            <Route path="/account" component={ChainAccount} />
            <Route path="/parameters" component={ClinicTreatmentParameters} />
            <Route path="/clinics" component={ChainClinics} />
            <Route path="/clinic/:id" component={ChainClinic} />
            <Route path="/reports" component={ChainReports}/>
            <Route path="/report/:token" component={ChainReport}/>
            <Route path="/equipment/platforms" component={ChainPlatformsPage} />
            <Route path="/equipment/platform/:id" component={ChainPlatform} />
            <Route path="/equipment/applicators" component={ChainApplicatorsPage} />
            <Route path="/treatments" component={ChainTreatments} />
            <Route path="/service" component={ChainService} />
            <Route path="/content/:title" component={TermsAgreement} />
            <Route exact path="/staff" component={ChainStaffMembers} />
            <Route path="/staff/:id" component={ChainStaffMember} />
            <Route path="/patients" component={ChainPatients} />
            <Route path="/patient/:id" component={ChainPatient} />
            <Route path={`/help`} component={HelpCenter}/>
            <Route path={`/email/preferences`} component={ClinicEmailPreferences}/>

            <Route exact path="/">
                <Redirect to="/dashboard"/>
            </Route>
            <Route exact path="/login">
                <Redirect to="/dashboard"/>
            </Route>

            <Route path="*" component={PageNotFound} />
        </Switch>
    </Suspense>
);

export const createDistributorRoutes = () => (
    <Suspense fallback={<p>LOADING...</p>}>
        <Switch>
            <Route path="/404" component={PageNotFound}/>

            <Route exact path="/dashboard" component={DistributorDashboard} />
            <Route path="/account" component={DistributorAccount} />
            <Route path="/clinics" component={DistributorClinicsAndChains} />
            <Route path="/clinic/:id" component={DistributorClinic} />
            <Route path="/reports" component={DistributorReports}/>
            <Route path="/report/:token" component={DistributorReport}/>
            <Route path="/equipment/platforms" component={DistributorPlatforms} />
            <Route path="/equipment/platform/:id" component={DistributorPlatform} />
            <Route path="/equipment/applicators" component={DistributorApplicators} />
            <Route path="/service" component={DistributorService} />
            <Route path={`/help`} component={HelpCenter}/>
            <Route path={`/email/preferences`} component={ClinicEmailPreferences}/>
            <Route path="/content/:title" component={TermsAgreement} />
            <Route exact path="/">
                <Redirect to="/dashboard"/>
            </Route>
            <Route exact path="/login">
                <Redirect to="/dashboard"/>
            </Route>

            <Route path="*" component={PageNotFound} />
        </Switch>
    </Suspense>
);

export const createAdminRoutes = () => (
    <Suspense fallback={<p>LOADING...</p>}>
        <Switch>
            <Route path="/404" component={PageNotFound}/>

            <Route exact path="/dashboard" component={AdminDashboard}/>
            <Route path="/distributors" component={AdminDistributors} />
            <Route path="/distributor/:id" component={AdminDistributor} />
            <Route path="/account" component={AdminAccount} />
            <Route path="/clinics" component={AdminClinicsAndChains} />
            <Route path="/clinic/:id" component={AdminClinic} pageHeader={'This is a sticky page header'}/>
            <Route exact path="/users" component={AdminUsers} />
            <Route path="/equipment/platforms" component={AdminPlatforms} />
            <Route path="/equipment/platform/:id" component={AdminPlatform} />
            <Route path="/equipment/platform-versions" component={AdminPlatformVersions} />
            <Route path="/equipment/applicators" component={AdminApplicators} />
            <Route path="/service" component={AdminService} />
            <Route path={`/help`} component={HelpCenter}/>
            <Route path={`/email/preferences`} component={ClinicEmailPreferences}/>
            <Route path="/content/:title" component={TermsAgreement} />
            <Route exact path="/">
                <Redirect to="/dashboard"/>
            </Route>
            <Route exact path="/login">
                <Redirect to="/dashboard"/>
            </Route>

            <Route path="*" component={PageNotFound} />
        </Switch>
    </Suspense>
);

// export default createRoutes;
